import { DateTime } from 'luxon';
import React, { useState } from 'react';
import { MdArrowLeft, MdArrowRight } from "react-icons/md";
import { DATE_FORMAT_SERVER } from '../../../../constants';

const YearCalendar = ({
    dateRanges,
    setDateRanges,
}) => {
    const currentYear = DateTime.now().year;
    const [startYear, setStartYear] = useState(Math.floor(currentYear / 10) * 10);

    const handlePrevYears = () => setStartYear(prev => prev - 10);
    const handleNextYears = () => setStartYear(prev => prev + 10);

    // Generate the list of 10 years
    const years = Array.from({ length: 10 }, (_, i) => startYear + i);

    const isYearSelected = (year) => {
        const start = DateTime.fromObject({ year }).startOf("year").toFormat(DATE_FORMAT_SERVER);
        return dateRanges.some(range => range.start === start);
    };

    const toggleYear = (year) => {
        const start = DateTime.fromObject({ year }).startOf("year").toFormat(DATE_FORMAT_SERVER);
        const end = DateTime.fromObject({ year }).endOf("year").toFormat(DATE_FORMAT_SERVER);

        const alreadySelected = dateRanges.some(range => range.start === start);

        if (alreadySelected) {
            // Don't allow deselecting the last one
            if (dateRanges.length <= 1) return;
            setDateRanges(dateRanges.filter(range => range.start !== start));
        } else {
            // Add and sort by start date
            const updated = [...dateRanges, { start, end }];
            updated.sort((a, b) => a.start.localeCompare(b.start));
            setDateRanges(updated);
        }
    };

    return (
        <div className='z-[100] absolute top-0 right-0 p-5 bg-white w-[300px] shadow-xl'>
            <div className='flex items-center justify-between'>
                <button
                    onClick={handlePrevYears}
                    type='button'
                    className='w-[20px] h-[20px] bg-gray-200 rounded-[2px] flex items-center justify-center'
                >
                    <MdArrowLeft className="text-xl flex-shrink-0" />
                </button>
                <p className='text-sm font-bold'>
                    {startYear} - {startYear + 9}
                </p>
                <button
                    onClick={handleNextYears}
                    type='button'
                    className='w-[20px] h-[20px] bg-gray-200 rounded-[2px] flex items-center justify-center'
                >
                    <MdArrowRight className="text-xl flex-shrink-0" />
                </button>
            </div>

            {/* Year Selector */}
            <div className='mt-3 grid grid-cols-2 gap-2'>
                {years.map((year) => {
                    const selected = isYearSelected(year);
                    return (
                        <button
                            key={year}
                            onClick={() => toggleYear(year)}
                            type="button"
                            className={`transition-all text-xs text-center p-2 rounded font-medium 
                                hover:cursor-pointer hover:bg-primary hover:text-white
                                ${selected ? "bg-primary text-white" : "bg-gray-100"}
                            `}
                        >
                            {year}
                        </button>
                    );
                })}
            </div>

            {/* Selected badges */}
            <div className='mt-3 flex flex-wrap gap-1 max-h-[80px] overflow-y-auto'>
                {dateRanges.map((range) => {
                    const label = DateTime.fromISO(range.start).toFormat('yyyy');
                    return (
                        <span
                            key={range.start}
                            className='inline-flex items-center gap-1 px-2 py-0.5 bg-primary/10 text-primary text-xs rounded-full font-medium'
                        >
                            {label}
                            {dateRanges.length > 1 && (
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setDateRanges(dateRanges.filter(r => r.start !== range.start));
                                    }}
                                    className='hover:text-red-500 font-bold text-[10px] leading-none'
                                >
                                    ✕
                                </button>
                            )}
                        </span>
                    );
                })}
            </div>
        </div>
    );
};

export default YearCalendar;
